//NB: this only used in open ai chat - putting it in dedicated file
//since that file is very big atow

export const useScroll = (scrollRef: React.RefObject<HTMLDivElement>) => {
  // Scroll to the bottom when the component first renders
  const scrollToBottom = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  };

  // Custom scroll function, slowly scroll the div
  const scrollSlowlyToBottom = () => {
    const target = scrollRef.current;
    if (target) {
      const start = target.scrollTop;
      const end = target.scrollHeight;
      const duration = 1000; // in milliseconds
      let startTime: number | null = null;

      const animateScroll = (time: number) => {
        if (startTime === null) startTime = time;
        const timeElapsed = time - startTime;
        const nextScrollPosition = easeInOutQuad(
          timeElapsed,
          start,
          end - start,
          duration
        );
        target.scrollTop = nextScrollPosition;

        if (timeElapsed < duration) {
          requestAnimationFrame(animateScroll);
        }
      };

      requestAnimationFrame(animateScroll);
    }
  };

  // Easing function for smooth scrolling
  const easeInOutQuad = (t: number, b: number, c: number, d: number) => {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  };

  return { scrollToBottom, scrollSlowlyToBottom };
};
